import AssetType from './asset-type.enum';
import AUM from './aum.enum';
import ChannelPartnerOraganizationRole from './channel-partner-organization-role.enum';
import ChannelPartnerType from './channel-partner-type.enum';
import DistributorCategory from './distributor-category.enum';
import FocusedArea from './focused-area.enum';
import UnregisteredCustomerType from './unregistered-customer-type.enum';
import {
  HTTPStatusCode,
  HTTPContentType,
  HTTPMethod,
  HTTPHeader,
} from './HttpConstants';
import { PropertyFitoutsDoneBy } from './property-fitouts-done-by.enum';
import { PropertyLocationType } from './property-location-type.enum';
import { PropertyStatus } from './property-status.enum';
import { PropertyStage } from './property-stage.enum';

import { DocumentType } from './document-type.enum';

import {
  AddressProofType,
  BankAccountType,
  KycProofStatus,
  KycStatus,
  ResidentialStatus,
  AccountType,
  AddressType,
  HolderType,
  AddressBelongsTo,
  KycProofType,
  EKycProofType,
  DecentroEKycProofType,
  DematStatus,
} from './customer-kyc.enum';
import UserEventCategory from './user-event-category.enum';
import { PropertyAmenities } from './property-amenities.enum';
import { PropertyType } from './property-type.enum';
import TransactionStatus from './transaction-status.enum';
import PgProvider from './pg-provider.enum';
import EnquiryType from './enquiry-type.enum';
import ReferralStatus from './referral-status.enum';
import TransactionFor from './transaction-for.enum';
import InvestmentStage from './investment-stage.enum';
import EOIDocumentSigningStatus from './eoi-document-signing-status.enum';
import EOIPaymentStatus from './eoi-payment-status.enum';
import InvestmentAmountType from './investment-amount-type.enum';
import { PropertyCostBreakup } from './property-cost-breakup.enum';
import InvestmentPropertyStatus from './investment-property-status';
import { ESignSimulateType } from './e-sign-simulate-type.enum';
import InvestmentStatus from './investment-status.enum';
import { EarningsDocumentType } from './earnings-documents-type.enum';
import { MethodOfPayment } from './generateReciept.enums';
import SignUpAttemptSources from './signup-attemp-sources.enum';
import { ChannelPartnerCustomerLinkageType } from './channel-partner-customer-linkage-type.enum';
import { LeadManagersDesignation } from './lead-managers-designation.enum';
import PaymentGatewayProvider from './payment-gateway-provider.enum';
import CommissionType from './channel-partner-commission-type.enum';
import ChannelPartnerInvoiceStatus from './channel-partner-invoice-status.enum';
import DocumentTemplateType from './document-template-type.enum';
import {
  OutBoundActivityFields,
  InBoundActivityFields,
  ActivityCode,
  OpportunityStatus,
  LeadUpdatedActivityFields,
  LeadFollowUpActivityFields,
  LeadStageCodeName,
  OpportunityStage,
  EngagementPhoneCallActivityFields,
  EngagementMeetingActivityFields,
  LeadLoginActivityFields,
  LeadLogoutActivityFields,
  LeadSignupActivityFields,
  LeadEnquiryActivityFields,
  UserRegistrationActivityFields,
  UserEnrolledActivityFields,
  LeadTypes,
  LeadSource,
  LeadSubSource,
  LeadOwnerChangeFields,
} from './lsq.enum';
export {
  HTTPContentType,
  HTTPHeader,
  HTTPMethod,
  HTTPStatusCode,
  PropertyFitoutsDoneBy,
  PropertyLocationType,
  PropertyStatus,
  PropertyStage,
  PropertyCostBreakup,
  AssetType,
  AUM,
  ChannelPartnerType,
  DistributorCategory,
  FocusedArea,
  AddressProofType,
  BankAccountType,
  DematStatus,
  KycProofStatus,
  KycStatus,
  ResidentialStatus,
  AccountType,
  DocumentType,
  UserEventCategory,
  PropertyAmenities,
  PropertyType,
  AddressType,
  HolderType,
  MethodOfPayment,
  TransactionStatus,
  PgProvider,
  EnquiryType,
  ChannelPartnerOraganizationRole,
  CommissionType,
  AddressBelongsTo,
  ReferralStatus,
  TransactionFor,
  InvestmentStage,
  EOIDocumentSigningStatus,
  EOIPaymentStatus,
  InvestmentAmountType,
  KycProofType,
  InvestmentPropertyStatus,
  ESignSimulateType,
  InvestmentStatus,
  EarningsDocumentType,
  SignUpAttemptSources,
  ChannelPartnerCustomerLinkageType,
  LeadManagersDesignation,
  UnregisteredCustomerType,
  PaymentGatewayProvider,
  ChannelPartnerInvoiceStatus,
  EKycProofType,
  DecentroEKycProofType,
  OutBoundActivityFields,
  InBoundActivityFields,
  ActivityCode,
  OpportunityStatus,
  LeadUpdatedActivityFields,
  LeadFollowUpActivityFields,
  LeadStageCodeName,
  OpportunityStage,
  EngagementPhoneCallActivityFields,
  EngagementMeetingActivityFields,
  LeadLoginActivityFields,
  LeadLogoutActivityFields,
  LeadSignupActivityFields,
  LeadEnquiryActivityFields,
  UserRegistrationActivityFields,
  UserEnrolledActivityFields,
  LeadTypes,
  LeadSource,
  LeadSubSource,
  LeadOwnerChangeFields,
  DocumentTemplateType,
};
export * from './KycDropdowns';
export * from './EnumHelper';
